import { render, staticRenderFns } from "./WeightContent.vue?vue&type=template&id=f90ddb6a&"
import script from "./WeightContent.vue?vue&type=script&lang=js&"
export * from "./WeightContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f90ddb6a')) {
      api.createRecord('f90ddb6a', component.options)
    } else {
      api.reload('f90ddb6a', component.options)
    }
    module.hot.accept("./WeightContent.vue?vue&type=template&id=f90ddb6a&", function () {
      api.rerender('f90ddb6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/WeightContent.vue"
export default component.exports